import React from 'react';
import TimelineItem from './TimelineItem';
import { timelineData } from '../../data/timeline';

const Timeline = () => {
  return (
    <section className="mt-10 md:mt-20 relative px-4 md:px-0">
      <h2 className="text-2xl md:text-3xl text-center font-mono mb-8 md:mb-16">
        <span className="text-green-500">&lt;</span>
        <span className="text-fuchsia-500">TIMELINE</span>
        <span className="text-green-500">/&gt;</span>
      </h2>
      
      <div className="relative max-w-5xl mx-auto">
        {/* Vertical Timeline Line */}
        <div className="absolute left-8 md:left-1/2 transform md:-translate-x-[2px] top-0 bottom-0 w-1 bg-cyan-400" />
        
        {timelineData.map((item, index) => (
          <TimelineItem 
            key={index}
            startdate={item.startdate}
            enddate={item.enddate}
            company={item.company}
            role={item.role}
            responsibilities={item.responsibilities}
              isLeft={index % 2 === 0}
          />
        ))}
      </div>
    </section>
  );
};
export default Timeline;